import { render, staticRenderFns } from "./commentLists.vue?vue&type=template&id=7e10ac89&scoped=true&"
import script from "./commentLists.vue?vue&type=script&lang=js&"
export * from "./commentLists.vue?vue&type=script&lang=js&"
import style0 from "./commentLists.vue?vue&type=style&index=0&id=7e10ac89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e10ac89",
  null
  
)

export default component.exports